import React from 'react';

/** Layered watercolor waves, like the bottom of the cover. `to` = next section background. */
export function Waves({
  to = '#FFFFFF',
  className = ''
}: {
  to?: string;
  className?: string;
}) {
  return <svg aria-hidden="true" viewBox="0 0 1440 160" preserveAspectRatio="none" className={`block h-[80px] w-full sm:h-[130px] ${className}`} data-id="element-386" data-mp="ohm5yi5pj71i">
      <path d="M0 90 C 200 30, 380 140, 620 80 S 1040 20, 1440 70 L1440 160 L0 160Z" fill="#E5F0EE" data-id="element-387" data-mp="xi27vn6sy649" />
      <path d="M0 110 C 240 60, 420 150, 700 105 S 1120 60, 1440 100 L1440 160 L0 160Z" fill="#EEEBF7" data-id="element-388" data-mp="sizbss8sva8f" />
      <path d="M0 128 C 260 98, 520 160, 800 126 S 1200 102, 1440 122 L1440 160 L0 160Z" fill="#FCEEE4" data-id="element-389" data-mp="17fygo8c9ooz7" />
      <path d="M0 146 C 300 130, 600 160, 900 144 S 1260 136, 1440 144 L1440 160 L0 160Z" fill={to} data-id="element-390" data-mp="12glwxwgozy0u" />
    </svg>;
}